import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import LoginView from '@/views/LoginView.vue'
import DashboardView from '@/views/DashboardView.vue'
import LinksView from '@/views/LinksView.vue'
import LinkDetailView from '@/views/LinkDetailView.vue'
import AnalyticsView from '@/views/AnalyticsView.vue'
import AdminView from '@/views/AdminView.vue'
import KeysView from '@/views/KeysView.vue'
import TenantManagementView from '@/views/TenantManagementView.vue'
import ApiKeyManagementView from '@/views/ApiKeyManagementView.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/dashboard'
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: { requiresAuth: false }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardView,
      meta: { requiresAuth: true }
    },
    {
      path: '/links',
      name: 'links',
      component: LinksView,
      meta: { requiresAuth: true }
    },
    {
      path: '/links/:shortCode',
      name: 'link-detail',
      component: LinkDetailView,
      meta: { requiresAuth: true }
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: AnalyticsView,
      meta: { requiresAuth: true }
    },
    {
    path: '/keys',
    name: 'keys',
    component: KeysView,
    meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/tenants',
      name: 'tenant-management',
      component: TenantManagementView,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/apikeys',
      name: 'apikey-management',
      component: ApiKeyManagementView,
      meta: { requiresAuth: true, requiresAdmin: true }
    }
  ]
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.meta.requiresAdmin && !authStore.isAdmin) {
    next('/dashboard')
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
